import Axios from "src/network/Axios";
import { NetworkConfig } from "src/network/NetworkConfig";

export interface GetCitiesParameters {
    zip?: string;
    city?: string;
}

export interface GetStreetsInCityParameters {
    zip: string;
    streetName?: string;
}

export interface GetStreetNumbersInStreetParameters {
    streetId: string;
    streetNumber?: string;
}

export const GetCities = async (getCityParameters: GetCitiesParameters) => {
    try {
        const cityQuery = getCityParameters.city ? `${getCityParameters.city}%` : "%";
        const zipQuery = getCityParameters.zip ? `${getCityParameters.zip}%` : "%";

        const { data } = await Axios.getInstance().get(
            `${NetworkConfig.getCitiesUrl}?city=${cityQuery}&zip=${zipQuery}`,
            {
                urlWithoutParams: NetworkConfig.getCitiesUrl
            }
        );

        return data.cities;
    } catch (err) {
        console.error("Error getting cities: ", err);
        return [];
    }
};

export const GetCitiesByName = async (query: string) => {
    return await GetCities({ city: query });
};

export const GetCitiesByZip = async (query: string) => {
    return await GetCities({ zip: query });
};

export const GetStreetsInCity = async (getStreetsInCityParameters: GetStreetsInCityParameters) => {
    try {
        const streetNameQuery = getStreetsInCityParameters.streetName ?? "";

        const { data } = await Axios.getInstance().get(
            `${NetworkConfig.getStreetsInCityUrl}?zip=${getStreetsInCityParameters.zip}&streetname=${streetNameQuery}%`,
            {
                urlWithoutParams: NetworkConfig.getStreetsInCityUrl
            }
        );

        const foundStreets = data.streets
            .map((street: any) => {
                return {
                    id: street.id,
                    street: street.name
                };
            })
            .sort((streetA: any, streetB: any) => {
                if (streetA.street < streetB.street) {
                    return -1;
                }

                if (streetA.street > streetB.street) {
                    return 1;
                }

                return 0;
            });

        return foundStreets;
    } catch (err) {
        console.error("Error getting streets: ", err);
        return [];
    }
};

export const GetStreetNumbersInStreet = async (streetid: string) => {
    try {
        const { data } = await Axios.getInstance().get(
            `${NetworkConfig.getStreetNumbersInStreetUrl}?streetid=${streetid}`,
            {
                urlWithoutParams: NetworkConfig.getStreetNumbersInStreetUrl
            }
        );

        let foundStreetNumbers = data.streetnumbers[0].numbers;

        var collator = new Intl.Collator("de-ch", { numeric: true, sensitivity: "base" });
        foundStreetNumbers.sort(collator.compare);
        foundStreetNumbers = foundStreetNumbers.filter((number: string) => number !== "");
        return foundStreetNumbers;
    } catch (err) {
        console.error("Error getting street numbers: ", err);
        return [];
    }
};
